<div class="info-wrapper">
  <i class="icon-Info"></i>
  <span>{{ infoText() }}</span>
</div>
